import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    style={{
      enableBackground: "new 0 0 45 45",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path fill={props.background} d="M12.8 7.3v13.8c0 .3.2.6.4.7l11 4.8c.1 0 .2.1.3.1s.2 0 .3-.1l11-4.8c.3-.1.4-.4.4-.7v-14c0-.1-.1-.1-.1-.2-.1-.2-.1-.2-.2-.3l-11-4.8c-.2-.1-.4-.1-.6 0l-11 4.8c-.1 0-.1.1-.2.1 0 .1-.1.1-.1.2-.2.2-.2.3-.2.4zm1.5 1.2 9.5 4.2v12.2l-9.5-4.2V8.5zM19 5.8l9.2 4-3.6 1.6-9.2-4L19 5.8zm6.3 19V12.7l4-1.8v5.4c0 .4.3.8.8.8s.8-.3.8-.8v-6.1l4-1.8v12.2l-9.6 4.2zm-.7-21.5 9.2 4-3.6 1.6-9.2-4 3.6-1.6zM43.2 34.9c-1.1-2.5-3.8-3.8-6.3-3.1l-5.6 1.5c-.2-2.3-1.4-3.7-3.9-4.4l-15.9-3.6v-.4c0-.2-.1-.4-.2-.6-1.4-1.4-7.5-1.8-8.8-1.9-.2 0-.4.1-.6.2-.2.1-.2.3-.2.5v15.2c0 .4.3.8.8.8H8c.3 0 .6-.2.7-.6 0-.1.1-.3.2-.7l12.6 4.7c1.3.4 2.2.7 3.4.7 1.9 0 4.1-.8 8.6-2.8l9.3-4.6c.4-.1.6-.6.4-.9zm-40 2.7V24c2.5.2 5.6.7 6.7 1.2-.3 3.8-2 10.4-2.5 12.4H3.2zm29.7 1.5c-7 3.1-8 3-10.8 2L9.3 36.4c.6-2.4 1.5-6.5 2-9.6L27 30.4c2 .5 2.8 1.4 2.8 3.3l-1.7.5c-.6.2-1.3.2-1.9 0l-7.4-1.6c-.4-.1-.8.2-.9.6-.1.4.2.8.6.9l7.4 1.6c.4.1.8.1 1.2.1.5 0 1-.1 1.4-.2l2.3-.6 6.5-1.8c1.6-.4 3.2.2 4.1 1.6l-8.5 4.3z" />
  </svg>
)

export default SvgComponent
